import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import ODMPCListingsMobile from "./mobile-uis/ODMPCListingsMobile";
import { formatDateTimezon } from "../common-data/Converts";
import {
  CallIcon,
  CheckCircleIcon,
  CrossCircleIcon,
  ExcludeIcon,
  EyeIcon,
  PersonIcon,
  EmailIcon,
  CalenderIcon,
  ClockIconV3,
} from "../../images/icons/icons";
import CalendarLoader from "../common-components/CalendarLoader";
import CommonTable from "../common-components/common-tables/CommonTable";
import SortableHeader from "../common-components/SortableHeader";

const ODMPCListings = (props) => {
  const { odmAllLoading, odmAllError, odmAll } = useSelector(
    (state) => state.api
  );

  const {
    isPage,
    setIsPage,
    pageLimit,
    setPageLimit,
    setModValues,
    allFilters,
    setAllFilters,
    isFromLMS,
  } = props || {};

  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const handleLMSSort = (field, event) => {
    if (event.detail === 2 || event.type === "dblclick") {
      setAllFilters((prevs) => ({ ...prevs, selectedLMSSorting: "" }));
      return;
    }
    if (event.direction === "asc") {
      setAllFilters((prevs) => ({ ...prevs, selectedLMSSorting: "0" }));
    } else if (event.direction === "desc") {
      setAllFilters((prevs) => ({ ...prevs, selectedLMSSorting: "1" }));
    } else {
      setAllFilters((prevs) => ({
        ...prevs,
        selectedLMSSorting: prevs.selectedLMSSorting === "0" ? "1" : "0",
      }));
    }
  };

  const handleDateAddedSort = (field, event) => {
    if (event.detail === 2 || event.type === "dblclick") {
      setAllFilters((prevs) => ({ ...prevs, selectedDateAddedSorting: "" }));
      return;
    }
    if (event.direction === "asc") {
      setAllFilters((prevs) => ({ ...prevs, selectedDateAddedSorting: "0" }));
    } else if (event.direction === "desc") {
      setAllFilters((prevs) => ({ ...prevs, selectedDateAddedSorting: "1" }));
    } else {
      setAllFilters((prevs) => ({
        ...prevs,
        selectedDateAddedSorting:
          prevs.selectedDateAddedSorting === "0" ? "1" : "0",
      }));
    }
  };

  useEffect(() => {
    if (
      !odmAllLoading &&
      !odmAllError &&
      odmAll?.status &&
      odmAll?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: odmAll.data,
        pagination: odmAll?.pagination?.length > 0 ? odmAll.pagination : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [odmAllLoading, odmAllError, odmAll]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: isFromLMS ? (
        "Action"
      ) : (
        <SortableHeader
          text="Action"
          field="added_to_lead"
          onSort={handleLMSSort}
          sortDirection={
            allFilters.selectedLMSSorting === "0"
              ? "asc"
              : allFilters.selectedLMSSorting === "1"
              ? "desc"
              : null
          }
          isSorted={!!allFilters.selectedLMSSorting}
        />
      ),
      formatter: (_, row) => (
        <div className="pp-employee-payroll-actions">
          {row?.added_to_lead ? (
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "view-lead-journey",
                }))
              }
            >
              <EyeIcon />
              View Lead
            </button>
          ) : (
            <button
              key="add-to-lmd"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                }))
              }
            >
              <ExcludeIcon />
              Add To LMS
            </button>
          )}

          <button
            key="click-to-call"
            type="button"
            className="pp-employee-payroll-action-button pp-outlined-border"
            onClick={() => {
              setModValues({
                isModOpen: true,
                modName: "click-to-call",
                rowData: row,
              });
            }}
          >
            <CallIcon color="#000" />
            click to call
          </button>
        </div>
      ),
    },
    {
      dataField: "user_id",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "odm",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.user_name || "NA"}</span>
            </div>

            {row?.user_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.user_mobile || "NA"}</span>
              </div>
            )}

            {row?.user_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">
                  {row.user_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <div className="tb-flex-col">
            {row?.gym_id && row?.gym_name ? (
              <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
                {gymName}
              </span>
            ) : (
              <button
                type="button"
                className="tb-map-gym-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "map-gym",
                    rowData: row,
                  }));
                }}
              >
                click to Map Gym
              </button>
            )}

            {row?.gym_alias && (
              <span className="tb-data lowercase underline gray">
                {row.gym_alias || ""}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: (
        <SortableHeader
          text="Date Added"
          field="date_added"
          onSort={handleDateAddedSort}
          sortDirection={
            allFilters.selectedDateAddedSorting === "0"
              ? "asc"
              : allFilters.selectedDateAddedSorting === "1"
              ? "desc"
              : null
          }
          isSorted={!!allFilters.selectedDateAddedSorting}
        />
      ),
      formatter: (_, row) => {
        const dateTime = row?.date_added ? row.date_added.split(" ") : null;
        const datePart = dateTime ? dateTime[0] : "-";
        const timePart = dateTime ? dateTime[1] + " " + dateTime[2] : "-";

        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalenderIcon />
              </span>
              <span className="tb-data">{datePart}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 />
              </span>
              <span className="tb-data">{timePart}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "keyword",
      text: "Landing Page Name",
      formatter: (_, row) => {
        return (
          <span className={`tb-data ${row?.keyword ? "lowercase" : ""}`}>
            {row?.keyword || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "visit_scheduled",
      text: "visit scheduled",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.visit_scheduled ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "visit_done",
      text: "visit done",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.visit_done ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "is_payment_done",
      text: "ODM Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.is_payment_done ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "plan status",
      formatter: (_, row) => {
        const planStatus = row?.current_plan_status
          ?.replace(/ /g, "_")
          ?.toLowerCase();

        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data ${planStatus ? "tb-badge" : ""} ${
                planStatus === "converted"
                  ? "tb-badge-success"
                  : planStatus === "pending"
                  ? "tb-badge-success-1"
                  : planStatus === "expired"
                  ? "not-assigned"
                  : planStatus
                  ? "tb-badge-success-2"
                  : ""
              }`}
            >
              {planStatus === "pending"
                ? "Upcoming Followup"
                : row?.current_plan_status?.replace(/_/g, " ") || "NA"}
            </span>
            {row?.subscription_expiry_days && (
              <span className="tb-data">
                {row.subscription_expiry_days || ""}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.added_on_lead ? formatDateTimezon(row.added_on_lead) : "-"}
            </span>
            {row?.add_to_lms_time_dif && (
              <span className="tb-data">{row?.add_to_lms_time_dif || "-"}</span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "last_follow_up_status",
      text: "last followup status",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.last_follow_up_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "current_follow_up_status",
      text: "current followup status",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.current_follow_up_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "lead_from",
      text: "lead from",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.lead_from?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <Row>
      <Col>
        <div className="common-table-container tb-bordered hideMobile mt15">
          <CommonTable
            tableData={allDatas.allLeads}
            tablePagination={allDatas.pagination}
            tableColumns={tbColumns}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={odmAllLoading}
          />
        </div>

        <div className="lead-logs-card-container only-mobile">
          {odmAllLoading ? (
            <CalendarLoader daysCount={5} shiftsPerDay={2} />
          ) : (
            <ODMPCListingsMobile
              tableData={allDatas.allLeads}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ODMPCListings;
